import { createFileRoute } from '@tanstack/react-router'
import { PaintCorrectionPage } from '../components/pages/PaintCorrectionPage'
import { publicPageHead } from '../lib/seo'

export const Route = createFileRoute('/paint-correction')({
  component: PaintCorrectionPage,
  head: () => publicPageHead({
    title: 'Paint Correction | Bellarine & Geelong | Autoglow',
    description:
      'Paint correction from Autoglow in Drysdale for the Bellarine and Geelong. Swirl reduction, paint clarity, gloss restoration and preparation for ceramic coating, quoted after inspection.',
    path: '/paint-correction',
    ogDescription: 'Professional paint correction from Autoglow in Drysdale, serving the Bellarine and Geelong.',
  }),
})
